<div fxLayout="column" fxLayoutAlign="start center">
    <mat-card class="drop-shadow-on-print timesheet-print" *ngIf="timesheet">
        <mat-grid-list cols="20" rowHeight="55px" gutterSize="0">
            <mat-grid-tile colspan="6">
                <img
                    src="assets/images/peopleware_logo.png"
                    alt=""
                    style="object-position: left; width: 216px; height: 55px" />
            </mat-grid-tile>

            <mat-grid-tile class="no-print" colspan="1"> </mat-grid-tile>

            <mat-grid-tile class="warn" *ngIf="!isProdEnv" colspan="4"
                >This is data from a TEST database!
            </mat-grid-tile>

            <!-- EMPLOYEE, CLIENT AND PROJECT - RIGHT SIDE -->

            <mat-grid-tile class="no-print" colspan="1"> </mat-grid-tile>

            <mat-grid-tile class="no-print" [class.ppw-stamp-approved]="timesheet.state !== 0" colspan="2">
            </mat-grid-tile>

            <mat-grid-tile class="no-print" colspan="1"> </mat-grid-tile>

            <mat-grid-tile
                class="no-print"
                [class.ppw-stamp-invoiced]="timesheet.invoiced"
                [class.ppw-stamp-do-not-invoice]="!timesheet.toInvoice"
                colspan="2">
            </mat-grid-tile>

            <mat-grid-tile class="no-print" colspan="1"> </mat-grid-tile>

            <mat-grid-tile [class.ppw-stamp-confidential]="!timesheet.sendToCustomer" colspan="2"> </mat-grid-tile>
        </mat-grid-list>

        <mat-divider [inset]="true" style="margin-top: 10px; margin-bottom: 10px"></mat-divider>

        <mat-grid-list cols="100" rowHeight="30px" gutterSize="0px" class="timesheet-header-font">
            <!-- FIRST ROW -->

            <mat-grid-tile class="tile-align-left tile-bold" rowspan="1" colspan="15">
                <span class="capitalize">timesheet for:</span>
            </mat-grid-tile>

            <mat-grid-tile class="tile-align-left tile-bold" rowspan="1" colspan="40">
                <span class="capitalize color-ppw-blue">{{ timesheet.employee.fullName }}</span>
            </mat-grid-tile>

            <mat-grid-tile class="tile-align-left tile-bold" rowspan="1" colspan="20">
                <span class="capitalize">month:</span>
            </mat-grid-tile>

            <mat-grid-tile class="tile-align-left" rowspan="1" colspan="25">
                <span class="capitalize">{{ timesheet.month + ' ' + timesheet.year }}</span>
            </mat-grid-tile>

            <!-- SECOND ROW -->

            <mat-grid-tile class="tile-align-left tile-bold" rowspan="1" colspan="15">
                <span class="capitalize">Client:</span>
            </mat-grid-tile>

            <mat-grid-tile class="tile-align-left tile-bold" rowspan="1" colspan="40">
                <span class="capitalize color-ppw-blue">{{ timesheet.timesheetProject.clientName }}</span>
            </mat-grid-tile>

            <mat-grid-tile class="tile-align-left tile-bold" rowspan="1" colspan="20">
                <span class="capitalize">total invoiced:</span>
            </mat-grid-tile>

            <mat-grid-tile class="tile-align-left" rowspan="1" colspan="25">
                <span class="capitalize">{{ dayHoursToInvoice }}</span>
            </mat-grid-tile>

            <!-- THIRD ROW -->

            <mat-grid-tile class="tile-align-left tile-bold" rowspan="1" colspan="15">
                <span class="capitalize">project:</span>
            </mat-grid-tile>

            <mat-grid-tile class="tile-align-left tile-bold" rowspan="1" colspan="40">
                <span class="capitalize color-ppw-blue">{{ timesheet.timesheetProject.name }}</span>
            </mat-grid-tile>

            <mat-grid-tile class="tile-align-left tile-bold" rowspan="1" colspan="20">
                <span class="capitalize">total not invoiced:</span>
            </mat-grid-tile>

            <mat-grid-tile class="tile-align-left" rowspan="1" colspan="25">
                <span class="capitalize">{{ dayHoursNoInvoice }}</span>
            </mat-grid-tile>

            <!-- FOURTH ROW -->
            <ng-container *ngIf="isViewByTag">
                <mat-grid-tile class="tile-align-left tile-bold" rowspan="1" colspan="15">
                    <span class="capitalize">tag:</span>
                </mat-grid-tile>

                <mat-grid-tile class="tile-align-left tile-bold" rowspan="1" colspan="40">
                    <span class="lowercase color-ppw-blue">{{ timesheet.tag }}</span>
                </mat-grid-tile>

                <mat-grid-tile class="tile-align-left" rowspan="1" colspan="20"> </mat-grid-tile>

                <mat-grid-tile class="tile-align-left" rowspan="1" colspan="25"> </mat-grid-tile>
            </ng-container>
        </mat-grid-list>
        <div fxLayout="row" class="ppw-background header-table">
            <div class="left-border top-border fxFlex-16">
                <span class="capitalize">date</span>
            </div>
            <div class="fxFlex-84">
                <div class="top-border left-border fxFlex-12">
                    <span class="capitalize"> invoiced </span>
                </div>
                <div class="top-border left-border fxFlex-12">
                    <span class="capitalize"> not invcd. </span>
                </div>
                <div class="left-border top-border right-border fxFlex-76">
                    <span class="capitalize"> description </span>
                </div>
            </div>
        </div>

        <!-- NG-REPEAT FOR EACH DAY OF THE MONTH -->
        <ppw-day-representation-row
            *ngFor="let day of daysInMonth; trackBy: trackBy; let last = last"
            style="padding: 0"
            [dayRep]="day"
            [isLast]="last">
        </ppw-day-representation-row>

        <!-- TOTALS AT THE BOTTOM OF THE PAGE -->
        <div fxLayout="row" class="dynamic-break">
            <div class="left-border bottom-border ppw-background fxFlex-16">
                <span class="capitalize">total</span>
            </div>
            <div class="fxFlex-84">
                <div class="bottom-border left-border ppw-background fxFlex-12">
                    <span class="capitalize">
                        {{ timesheet.hoursToCharge }}
                    </span>
                </div>
                <div class="bottom-border left-border right-border ppw-background fxFlex-12">
                    <span class="capitalize">
                        {{ timesheet.hoursNoCharge }}
                    </span>
                </div>
                <div class="left-border fxFlex-76"></div>
            </div>
        </div>
    </mat-card>
</div>
